import type { LearningModule } from '@/core/domain/learning/module/LearningModule.ts'
import type { ILearningModuleRepository } from '@/core/domain/learning/module/ILearningModuleRepository.ts'
import type { ILearningModuleUrlOptions } from '@/core/domain/learning/module/ILearningModuleUrlOptions.ts'

export class FetchAllLearningModulesUseCase {
  private learningModuleRepository: ILearningModuleRepository

  constructor(learningModuleRepository: ILearningModuleRepository) {
    this.learningModuleRepository = learningModuleRepository
  }

  async execute(courseId: number, options?: ILearningModuleUrlOptions): Promise<LearningModule[]> {
    return await this.learningModuleRepository.fetchAllLearningModules(courseId, options)
  }
}
